import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilesGuard implements CanActivate {

  videoId='';

  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {


    const moduleId = next.data.module;
    const userId = next.paramMap.get('user_id') || localStorage.getItem('user_id');
    const token = next.paramMap.get('token') || localStorage.getItem('token');

    localStorage.setItem('user_id', userId);

    this.videoId = next.paramMap.get('id');

    console.log('vidoeId: '+ this.videoId);

    if (userId && token) {
      return new Observable<boolean>((observer) => {
        this.authService.validarTokenYUserId(token, userId).subscribe({
          next: (res) => {
            if (res) {
              localStorage.setItem('token', token);
              this.authService.obtenerModulosPorUsuario(userId).subscribe(
                (modulos: any[]) => {
                  const modulesId = modulos.map(modulo => modulo.ModuleId);
                  localStorage.setItem("modulesId", modulesId.toString());
                  if (modulesId.includes(moduleId)) {
                    observer.next(true);
                  } else {
                    console.log('No tiene acceso al módulo');
                    this.exit();
                    observer.next(false);
                  }
                  observer.complete();
                },
                error => {
                  console.error('Error al obtener módulos:', error);
                  this.exit();
                  observer.next(false);
                  observer.complete();
                }
              );
            } else {
              console.error('No se validó el token y el usuario');
              if(this.videoId){
                this.public();
                observer.next(false);
                observer.complete();
              }
              else{
                this.exit();
                observer.next(false);
                observer.complete();
              }
            }
          },
          error: (err) => {
            console.error('Un error ocurrió');
            console.error(err);
            if(this.videoId){
              this.public();
              observer.next(false);
              observer.complete();
            }
            else{
              this.exit();
              observer.next(false);
              observer.complete();
            }
          },
        });
      });
    } else {
      console.error('No se proporcionó userId y token');
      if(this.videoId){
        this.public();
        return false;
      }
      else{
        this.exit();
        return false;
      }
    }
  }

  private exit(): void {
    console.log('guard exit');
    this.router.navigate(['/']);
  }

  public():void{
    this.router.navigate(['/public/detail/'+this.videoId])
  }
}
